import React from "react";
import { Address as AddressType } from "../../types";
import addressStyles from "./verify-address.module.css";

const Address: React.FC<{ address: AddressType; heading: string }> = ({ address, heading }) => (
  <div className={addressStyles.address}>
    <h3 className={addressStyles.addressHeading}>{heading}</h3>
    {address.address1} <br />
    {address.address2 && (
      <span>
        {address.address2} <br />
      </span>
    )}
    {address.city} <br />
    {address.state} <br />
    {address.zip} <br />
  </div>
);

export default Address;
